/**
 * Authentication-related constants
 */
export const AUTH = {
  TOKEN_EXPIRY_DAYS: 7,
  SELECTED_COMPANY_KEY: 'xkey-selected-company',
  /** After login, redirect to `/rekisteroidy/:code` so the user can accept the invitation. */
  PENDING_INVITATION_CODE_KEY: 'xkey-pending-invitation-code',
  /**
   * JWTs from the login/refresh JSON body (sessionStorage). Used as Authorization Bearer when the API
   * host differs from the SPA origin: HttpOnly cookies are not readable in JS, and Safari/WebKit may not
   * attach cross-site cookies on credentialed fetch the same way Chrome/Android does.
   */
  SESSION_ACCESS_TOKEN_KEY: 'xkey-session-access-token',
  SESSION_REFRESH_TOKEN_KEY: 'xkey-session-refresh-token',
} as const;
